import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class GameErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Game Error:', error, errorInfo);
    
    // Log to external service in production
    if (process.env.NODE_ENV === 'production') {
      // Add error logging service here
      console.log('Error logged to monitoring service');
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary" style={{
          padding: '40px',
          textAlign: 'center',
          background: 'var(--darker-bg)',
          borderRadius: 'var(--border-radius)',
          margin: '20px',
          border: '2px solid var(--error-color)'
        }}>
          <h2 style={{ color: 'var(--error-color)', marginBottom: '20px' }}>
            🚨 Something went wrong
          </h2>
          <p style={{ color: 'var(--text-light)', marginBottom: '20px' }}>
            The game encountered an unexpected error. Please refresh the page or try again later.
          </p>
          <button 
            onClick={() => window.location.reload()}
            className="btn btn-danger"
            style={{ marginRight: '10px' }}
          >
            Refresh Page
          </button>
          <button 
            onClick={() => this.setState({ hasError: false, error: null })}
            className="btn btn-secondary"
          >
            Try Again
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: '20px', textAlign: 'left' }}>
              <summary style={{ color: 'var(--warning-color)', cursor: 'pointer' }}>
                Error Details (Development)
              </summary>
              <pre style={{ 
                background: 'var(--dark-bg)', 
                padding: '10px', 
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '12px',
                color: 'var(--error-color)'
              }}>
                {this.state.error.stack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default GameErrorBoundary;

